import React from "react";
import {makeStyles} from 'tss-react/mui';

// core components
import Footer from "../../../components/Footer/Footer.js";
import Header from "../../../components/Header/Header.js";
import HeaderLinks from "../../../components/Header/HeaderLinks.js";
import logo from "../../../public/img/logo.png";
import Parallax from "../../../components/Parallax/Parallax";

import styles from "../../../styles/jss/nextjs-material-kit/pages/jobAndCoursesStyle.js";

// Sections for this page
import PreFooter from "../../../pages-sections/LandingPage-Sections/PreFooter.js";
import OrganisationDetails from "../../../pages-sections/LandingPage-Sections/OrganisationDetails";
import {buildSlug} from "../../../util/url";
import Head from "next/head";
import {client} from "../../../request/client";
import useSWR, {SWRConfig} from "swr";
import JSONSchemaData from "../../../components/JSONSchemaData/JSONSchemaData";

const dashboardRoutes = [];
const useStyles = makeStyles()(styles);

function UniversityPage(props) {
  const { classes, cx } = useStyles();
  const { universityId, ...rest } = props;
  const { data, error, isLoading } = useSWR(`/v1/universities/${universityId}`);


  const jsonBreadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://successatschool.org/"
    }, {
      "@type": "ListItem",
      "position": 2,
      "name": "Universities",
      "item": "https://successatschool.org/universities"
    }, {
      "@type": "ListItem",
      "position": 3,
      "name": data?.name,
      "item": `https://successatschool.org/university/${buildSlug(data?.name)}/${data?.id}`
    }]};

  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        logo={logo}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <Head>
        <title>
          {data?.name}
        </title>
        <meta
            name="description"
            content={data?.description_short}
            key="desc"
        />
        {!!data && <>
          <link rel="canonical" href={`https://successatschool.org/university/${buildSlug(data.name)}/${data.id}`} />
        </>}
      </Head>
      <Parallax className="parallaxx-compact" filter image="/img/faces/universities_img.png" />

      {data && <OrganisationDetails org={data} isUniversity={true} />}

      <div className={cx(classes.darkBlue, "footer", "colored_bgg")}>
        <PreFooter />
      </div>
      <Footer />
      <JSONSchemaData key_name={'breadcrumbSchema'} data={jsonBreadcrumbData} />
    </div>
  );
}

export default function UniversityPageSwr({ fallback, ...rest }) {
  return (
      <SWRConfig value={{ fallback }}>
        <UniversityPage {...rest} />
      </SWRConfig>
  );
}

export async function getServerSideProps({ query }) {
  const { universityId } = query;

  try {
    let data = await client({
      url: `/v1/universities/${universityId}`,
      method: "get",
      headers: {},
    }).then((res) => res.data);

    return {
      props: {
        fallback: {
          [`/v1/universities/${universityId}`]: data,
        },
        universityId,
      }
    };
  }
  catch (e) {
    if (e.response && e.response.status === 404) {
      return {
        notFound: true,
      };
    }
    else {
      throw e;
    }
  }
}
